
import { computed, defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'MasterFormModal',

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    remove: {
      type: Function,
      required: true,
    },
    formModel: {
      type: Object,
      required: true,
    },
    removeItemTextProp: {
      type: String,
      required: true,
    },
    removeIdentifier: {
      type: String,
      default: () => 'uuid',
    },
  },

  emits: ['close'],

  setup(props, { emit }) {
    const route = useRoute()

    const disableInIdp = ref(false)

    function close() {
      emit('close')
    }

    async function confirm() {
      await props.remove(
        props.formModel[props.removeIdentifier],
        disableInIdp.value
      )

      close()
    }

    const removeItemText = computed(() => {
      return props.formModel[props.removeItemTextProp]
    })

    const isUserDelete = computed(() => route.path.includes('users'))

    return { close, confirm, removeItemText, isUserDelete, disableInIdp }
  },
})
